import { useState } from "react";
import { toast } from "sonner";
import { Loader2, BellRing } from "lucide-react";
import { api } from "@/lib/api";

export default function WaReadyButton({ sale, onDone }) {
    const [busy, setBusy] = useState(false);
    if (!sale.customer_phone) return null;
    const done = !!sale.ready_notified_at;

    const notify = async () => {
        if (done && !window.confirm("Klienti është njoftuar më parë. Ta njoftoj përsëri?")) return;
        setBusy(true);
        const win = window.open("", "_blank");
        try {
            const { data } = await api.post(`/admin/sales/${sale.id}/notify-ready`);
            if (data.wa_link && win) win.location.href = data.wa_link;
            else { win?.close(); toast.success("Klienti u njoftua në WhatsApp"); }
            onDone?.();
        } catch (e) {
            win?.close();
            toast.error(e?.response?.data?.detail || "Njoftimi dështoi");
        } finally {
            setBusy(false);
        }
    };

    return (
        <button
            onClick={notify}
            disabled={busy}
            className={`p-1.5 hover:scale-110 transition-transform ${done ? "text-emerald-600" : "text-amber-600"}`}
            title={done ? `Njoftuar: ${new Date(sale.ready_notified_at).toLocaleString()}` : "Njofto klientin: turboja është gati"}
            data-testid={`wa-ready-${sale.id}`}
        >
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <BellRing className="w-4 h-4" />}
        </button>
    );
}
